export default __webpack_public_path__ + "static/media/Path3455.9f729d09.svg";